"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Button;

var _Button2 = _interopRequireDefault(require("@material-ui/core/Button"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _UrlUtils = require("./utils/UrlUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Button(_ref) {
  var children = _ref.children,
      iconOnly = _ref.iconOnly,
      url = _ref.url,
      props = _objectWithoutProperties(_ref, ["children", "iconOnly", "url"]);

  var href = props.href,
      rel = props.rel,
      target = props.target,
      width = props.width;
  var linkProperties = (0, _UrlUtils.getLinkProperties)(href, rel, target, url);

  var buttonProps = _objectSpread(_objectSpread({}, props), linkProperties); // Unless a width is set, we like defaulting to fullWidth


  if (!width) {
    buttonProps.fullWidth = true;
  }

  var StyledIconButton = (0, _withStyles["default"])({
    root: {
      minWidth: 32
    },
    startIcon: {
      marginRight: 0
    },
    endIcon: {
      marginLeft: 0
    }
  })(_Button2["default"]);
  return iconOnly ?
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-props-no-spreading
  _react["default"].createElement(StyledIconButton, buttonProps, children) :
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-props-no-spreading
  _react["default"].createElement(_Button2["default"], buttonProps, children);
}